var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"absolute":_vm.absolute,"value":_vm.loading}},[_c('v-card',[_c('v-card-text',[_vm._t("default")],2),_c('v-progress-linear',{attrs:{"indeterminate":"","absolute":"","top":"","color":"primary"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }